var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"danger":""},on:{"click":_vm.confirmDelete}},[_c('TrashIcon',{staticClass:"w-4 h-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }